"use client";

import Analytics from "@/app/_components/analytics";
import { AppToolbar, AppToolbarLeftSlot } from "@/components/core/AppToolbar";
import SEO from "@/components/core/Seo";
import { MainContent } from "@/components/layout/MainContent";
import { ExternalWalletsList } from "@/components/wallets/ExternaWallets";
import { usePreferences } from "@/context/PreferencesProvider";
import { Heading } from "@biom3/react";
import { useEffect } from "react";

function ExternalWalletsContent() {
  const { data: preferencesData, update: updatePreferences } = usePreferences();

  useEffect(() => {
    if (preferencesData?.hide_activation_badges.external_wallets === false) {
      updatePreferences({
        hide_activation_badges: {
          ...preferencesData?.hide_activation_badges,
          external_wallets: true,
        },
      });
    }
  }, [preferencesData, updatePreferences]);

  return (
    <>
      <AppToolbar>
        <AppToolbarLeftSlot>
          <Heading size="small">External Wallets</Heading>
        </AppToolbarLeftSlot>
      </AppToolbar>
      <ExternalWalletsList />
    </>
  );
}

export default function ExternalWalletsPage() {
  return (
    <>
      <Analytics screen="ExternalWallets" userJourney="Wallets" />
      <SEO
        description="Link your EOA wallet (or hardware wallet) to your Passport wallet."
        title="External Wallets | Immutable Play"
        url="https://play.immutable.com/external-wallets"
      />
      <MainContent>
        <ExternalWalletsContent />
      </MainContent>
    </>
  );
}
